var _rect, _ellipse, _ellipse2, _g, _rect2, _path, _path2, _path3, _g2, _path4, _path5, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlobal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 120,
    viewBox: "0 0 178 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.378662,
    y: 101.923,
    width: 81.9994,
    height: 8.23345,
    fill: "url(#paint0_linear_1261_62278)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.2954,
    cy: 55.8325,
    rx: 53.3082,
    ry: 53.4247,
    fill: "white",
    stroke: "#DADCE0",
    strokeWidth: 1.90663
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1261_62278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 28,
    y: 1,
    width: 109,
    height: 110
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.2954,
    cy: 55.8325,
    rx: 53.3082,
    ry: 53.4247,
    fill: "white",
    stroke: "white",
    strokeWidth: 1.90663
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1261_62278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.3905,
    cy: 132.153,
    rx: 53.3082,
    ry: 53.4247,
    stroke: "#DADCE0",
    strokeWidth: 1.90663
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 82.3905,
    cy: -20.4884,
    rx: 53.3082,
    ry: 53.4247,
    stroke: "#DADCE0",
    strokeWidth: 1.90663
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1212,
    y: 2.40784,
    width: 2.53849,
    height: 106.849,
    fill: "#DADCE0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.699 54.5605V57.1045L29.0824 57.1045V54.5605L135.699 54.5605Z",
    fill: "#DADCE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0636 2.40785C61.7033 2.40785 55.7366 26.3269 55.7366 55.8325C55.7366 85.3381 61.7033 109.257 69.0636 109.257",
    stroke: "#DADCE0",
    strokeWidth: 1.90663
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7175 2.40785C103.078 2.40785 109.045 26.3269 109.045 55.8325C109.045 85.3381 103.078 109.257 95.7175 109.257",
    stroke: "#DADCE0",
    strokeWidth: 1.90663
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 117.586,
    y: 111.463,
    width: 38.339,
    height: 8.23345,
    fill: "url(#paint1_linear_1261_62278)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158.262 47.4698L126.84 77.8257",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.054 45.6298L154.065 46.9774L158.447 47.0162L158.486 51.3984L159.833 51.4088L159.789 45.6743L154.054 45.6298Z",
    fill: "#3C228A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1261_62278",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 154,
    y: 45,
    width: 6,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.054 45.6298L154.065 46.9774L158.447 47.0162L158.486 51.3984L159.833 51.4088L159.789 45.6743L154.054 45.6298Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1261_62278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.84 77.8257L111.512 73.1556",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.512 73.1556L91.5864 93.3929",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5865,
    cy: 91.8361,
    rx: 3.06552,
    ry: 3.11343,
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.512,
    cy: 73.1556,
    rx: 3.06552,
    ry: 3.11343,
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.84,
    cy: 77.8257,
    rx: 3.06552,
    ry: 3.11343,
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 148.299,
    cy: 57.5885,
    rx: 3.06552,
    ry: 3.11343,
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M133.737 93.024L138.382 97.7413",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M139.102 87.9444L143.772 92.6871",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M141.66 72.3772C141.66 85.5018 131.198 96.0465 118.41 96.0465C105.621 96.0465 95.1597 85.5018 95.1597 72.3772C95.1597 59.2526 105.621 48.708 118.41 48.708C131.198 48.708 141.66 59.2526 141.66 72.3772Z",
    stroke: "white",
    strokeWidth: 7.14648
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144.34 72.3772C144.34 86.9426 132.717 98.7264 118.41 98.7264C104.102 98.7264 92.4797 86.9426 92.4797 72.3772C92.4797 57.8119 104.102 46.0281 118.41 46.0281C132.717 46.0281 144.34 57.8119 144.34 72.3772Z",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M138.414 72.3772C138.414 83.6141 129.448 92.705 118.41 92.705C107.372 92.705 98.4053 83.6141 98.4053 72.3772C98.4053 61.1404 107.372 52.0495 118.41 52.0495C129.448 52.0495 138.414 61.1404 138.414 72.3772Z",
    fill: "#3C228A",
    fillOpacity: 0.12,
    stroke: "#3C228A",
    strokeWidth: 1.3757
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M155.545 118.727L137.29 100.186L145.791 91.5527L164.046 110.093L155.545 118.727Z",
    fill: "white",
    stroke: "#3C228A",
    strokeWidth: 1.78662
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144.467 100.398L146.766 98.063",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.766 98.063L155.508 106.942",
    stroke: "#3C228A",
    strokeWidth: 1.78662,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2746 38.0871C9.5023 36.3109 6.69173 35.5751 6.69173 35.5751C6.69173 35.5751 9.5023 34.8394 11.2746 33.0632C13.047 31.2869 13.7811 28.4702 13.7811 28.4702C13.7811 28.4702 14.5153 31.2869 16.2876 33.0632C18.06 34.8394 20.8705 35.5751 20.8705 35.5751C20.8705 35.5751 18.06 36.3109 16.2876 38.0871C14.5153 39.8633 13.7811 42.68 13.7811 42.68C13.7811 42.68 13.047 39.8633 11.2746 38.0871Z",
    fill: "#FFC220"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.982 11.1275C130.932 9.07226 127.68 8.22095 127.68 8.22095C127.68 8.22095 130.932 7.36965 132.982 5.31441C135.033 3.25917 135.883 0 135.883 0C135.883 0 136.732 3.25917 138.783 5.31441C140.834 7.36965 144.086 8.22095 144.086 8.22095C144.086 8.22095 140.834 9.07226 138.783 11.1275C136.732 13.1827 135.883 16.4419 135.883 16.4419C135.883 16.4419 135.033 13.1827 132.982 11.1275Z",
    fill: "#FFC220"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.207 89.2738C168.84 87.9036 166.672 87.3361 166.672 87.3361C166.672 87.3361 168.84 86.7686 170.207 85.3984C171.575 84.0282 172.141 81.8555 172.141 81.8555C172.141 81.8555 172.707 84.0282 174.074 85.3984C175.442 86.7686 177.61 87.3361 177.61 87.3361C177.61 87.3361 175.442 87.9036 174.074 89.2738C172.707 90.6439 172.141 92.8167 172.141 92.8167C172.141 92.8167 171.575 90.6439 170.207 89.2738Z",
    fill: "#FFC220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1261_62278",
    x1: 0.378662,
    y1: 109.507,
    x2: 69.4532,
    y2: 109.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1261_62278",
    x1: 117.586,
    y1: 119.048,
    x2: 149.882,
    y2: 119.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFF0F1",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DADCDF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobal);
export default __webpack_public_path__ + "static/media/global.b5c5b22ccf597aee3c8b370844ea94c0.svg";
export { ForwardRef as ReactComponent };